import { createTheme } from "@mui/material/styles";
import { theme } from "@piiqtechnologies/ui-components";
const customTheme = createTheme(theme, {
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif",
    },
});
export default customTheme;
